module.exports = __webpack_public_path__ + "img/feature2.126e6bec.png";